<template>
  <div class="EMPreview">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="设备维修详情"
        class="customer-edit"
        width="1000px"
        top="10vh">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="emRepairOrder"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <div style="font-size: 16px;margin-bottom: 2%">基本信息</div>
        <table class="table" cellpaddinng="0" cellspacing="0">
          <tr>
            <td>
              <span>工单编号:</span>
              <div style="width: 67%">{{emRepairOrder.no}}</div>
            </td>
            <td>
              <span>申请时间:</span>
              <div style="width: 67%">{{emRepairOrder.createTime}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <span>设备编号:</span>
              <div style="width: 67%">{{emRepairOrder.equipmentCode}}</div>
            </td>
            <td>
              <span>设备名称:</span>
              <div style="width: 67%">{{emRepairOrder.equipmentName}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <span>确认人姓名:</span>
              <div style="width: 67%">{{emRepairOrder.confirmName}}</div>
            </td>
            <td>
              <span>确认时间:</span>
              <div style="width: 67%">{{emRepairOrder.confirmTime}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <span>创建人姓名:</span>
              <div style="width: 67%">{{emRepairOrder.creatorName}}</div>
            </td>
            <td>
              <span>部门名称:</span>
              <div style="width: 67%">{{emRepairOrder.departmentName}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <span>状态:</span>
              <div style="width: 67%">
                {{constant.reportOrderStatus[emRepairOrder.status]}}
              </div>
            </td>
            <td>
              <span>紧急程度:</span>
              <div style="width: 67%">
                {{constant.urgencyType[emRepairOrder.urgency]}}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span>可供开始维修时间:</span>
              <div style="width: 67%">{{emRepairOrder.availableRepairBeginTime}}</div>
            </td>
            <td>
              <span>可供开始结束时间:</span>
              <div style="width: 67%">{{emRepairOrder.availableRepairEndTime}}</div>
            </td>
          </tr>
          <tr>
            <td>
              <span>故障描述:</span>
              <div style="width: 67%">
                {{emRepairOrder.faultDesc}}
              </div>
            </td>
            <td>
              <span>故障原因:</span>
              <div style="width: 67%">{{emRepairOrder.faultReason}}</div>
            </td>
          </tr>
          <tr>
            <td style="border-bottom: none">
              <span>预防措施:</span>
              <div style="width: 67%">{{emRepairOrder.recommendation}}</div>
            </td>
            <td style="border-bottom: none">
              <span>修理方式:</span>
              <div style="width: 67%">
                {{constant.dealMethod[emRepairOrder.repairType]}}
              </div>
            </td>
          </tr>
        </table>

        <div style="margin-bottom: 3%">
          <div style="font-size: 16px;margin-bottom: 2%">维修方式</div>
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column prop="repairMethod" width="100px" align="center" label="处理方法">
              <template slot-scope="scope">
                <span>{{constant.dealMethod[scope.row.repairMethod]}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="repairMan" align="center" width="100px" label="维修人员"/>
            <el-table-column prop="beginTime" align="center" width="140px" label="开始时间"/>
            <el-table-column prop="endTime" align="center" width="140px" label="结束时间"/>
            <el-table-column prop="estimatedCost" align="center" width="100px" label="预估费用"/>
            <el-table-column prop="repairContent" align="center" label="维修内容"/>
          </el-table>
        </div>
        <div style="font-size: 16px;margin-bottom: 2%;">维修结果</div>
        <div style="margin-top: 2%;border: 1px solid #cccccc;padding: 2% 0">
          <el-form-item label="修理结果:">
            <div>
              {{constant.result[emRepairOrder.result]}}
            </div>
          </el-form-item>
          <el-form-item label="验证方法和结果:">
            <span>{{emRepairOrder.confirmDesc}}</span>
          </el-form-item>
          <el-form-item label="OA编号:">
            <span>{{emRepairOrder.oaNo}}</span>
          </el-form-item>
          <el-form-item label="历史描叙:">
            <span>{{emRepairOrder.unusableDesc}}</span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"EMPreview",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        activeName: "first",
        value: "",
        emRepairOrder: {
          pkid: 0,
          availableRepairBeginTime: "",
          availableRepairEndTime: "",
          confirmName: "",
          confirmTime: "",
          confirmerId: "",
          createTime: "",
          creatorID: "",
          creatorName: "",//创建人
          departmentName: "",//部门名称
          equipmentCode: "",//设备代码
          equipmentId: "",//设备ID
          equipmentName: "",//设备名称
          faultDesc: "",
          faultReason: "",
          faultTime: "",
          isOutRepair: "",
          no: "",
          oaNo: "",
          recommendation: "",
          repairType: "",
          result: "",
          status: "",
          unusableDesc: "",
          urgency: "",
          emRepairOrderDetailVOS:[],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.emRepairOrder.pkid = id;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `emRepairOrders/${this.emRepairOrder.pkid}`)
          .then(resp => {
            this.emRepairOrder = resp;
            this.tableData = resp.emRepairOrderDetailVOS;
            console.log(this.tableData);
          });
      },
      onSelectEquipment(row) {
        this.emRepairOrder.equipmentId = row.pkid;
        this.emRepairOrder.equipmentName = row.name;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .EMPreview{
    .el-form-item__content{
      margin-left: 2%!important;
    }
    .table{
      width: 100%;
      border: 1px solid #cccccc;
      margin-bottom: 3%;
      tr{
        display: flex;
        flex-direction: row;
        td{
          width: 50%;
          line-height: 30px;
          border-bottom: 1px solid #cccccc;
          display: flex;
          flex-direction: row;
          span{
            display: block;
            margin-right: 2%;
            width: 28%;
            padding: 0 2% 0 0;
            background: #f5f5f5;
            border-right: 1px solid #cccccc;
            text-align: right;
          }
          .el-radio {
            line-height: 40px;
            margin-right: 10px;
            .el-radio__label{
              padding-left: 2px!important;
            }
          }
        }
        td:nth-child(1){
          border-right: 1px solid #cccccc;
        }
      }
    }
  }
</style>
